module.exports = __webpack_public_path__ + "static/media/Panexgine.cfa02b06.jpg";